import { ChangeDetectorRef, NgZone, Pipe, PipeTransform } from "@angular/core";

/**
 * Generated class for the TimeagoPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: "timeago",
})
export class TimeagoPipe implements PipeTransform {
  private timer;

  /**
   * @param {?} changeDetectorRef
   * @param {?} ngZone
   */
  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private ngZone: NgZone
  ) {}
  /**
   * @param {?} value
   * @return {?}
   */
  transform(value) {
    this.removeTimer();
    let /** @type {?} */ d = new Date(value);
    let /** @type {?} */ now = new Date();
    let /** @type {?} */ seconds = Math.round(
        Math.abs((now.getTime() - d.getTime()) / 1000)
      );
    let /** @type {?} */ timeToUpdate = Number.isNaN(seconds)
        ? 1000
        : this.getSecondsUntilUpdate(seconds) * 1000;
    this.timer = this.ngZone.runOutsideAngular(() => {
      if (typeof window !== "undefined") {
        return window.setTimeout(() => {
          this.ngZone.run(() => this.changeDetectorRef.markForCheck());
        }, timeToUpdate);
      }
      return null;
    });
    let /** @type {?} */ minutes = Math.round(Math.abs(seconds / 60));
    let /** @type {?} */ hours = Math.round(Math.abs(minutes / 60));
    let /** @type {?} */ days = Math.round(Math.abs(hours / 24));
    let /** @type {?} */ months = Math.round(Math.abs(days / 30.416));
    let /** @type {?} */ years = Math.round(Math.abs(days / 365));
    if (Number.isNaN(seconds)) {
      return "";
    } else if (seconds <= 45) {
      return "ahora";
    } else if (seconds <= 90) {
      return "hace un minuto";
    } else if (minutes <= 45) {
      return "hace " + minutes + " minutos";
    } else if (minutes <= 90) {
      return "hace una hora";
    } else if (hours <= 22) {
      return "hace " + hours + " horas";
    } else if (hours <= 36) {
      return "hace un día";
    } else if (days <= 25) {
      return "hace " + days + " días";
    } else if (days <= 45) {
      return "hace un mes";
    } else if (days <= 345) {
      return "hace " + months + " meses";
    } else if (days <= 545) {
      return "hace un año";
    } else {
      // (days > 545)
      return "hace " + years + " años";
    }
  }
  /**
   * @return {?}
   */
  ngOnDestroy() {
    this.removeTimer();
  }
  /**
   * @return {?}
   */
  removeTimer() {
    if (this.timer) {
      window.clearTimeout(this.timer);
      this.timer = null;
    }
  }
  /**
   * @param {?} seconds
   * @return {?}
   */
  getSecondsUntilUpdate(seconds) {
    let /** @type {?} */ min = 60;
    let /** @type {?} */ hr = min * 60;
    let /** @type {?} */ day = hr * 24;
    if (seconds < min) {
      // less than 1 min, update every 2 secs
      return 2;
    } else if (seconds < hr) {
      // less than an hour, update every 30 secs
      return 30;
    } else if (seconds < day) {
      // less then a day, update every 5 mins
      return 300;
    } else {
      // update every hour
      return 3600;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pipes/timeago/timeago.ts